import { CreateHypatiaJWE } from '@/lib/createJWT'
import { FeideTools } from '@/lib/feideTools'
// import router from '@/router/'
import { UdirTools } from '@/lib/udirTools'
import { encodeLoad, decodeLoad } from '@/lib/base64'

import { adminStore } from '@/stores/adminstore.js'
import { userStore } from '@/stores/userstore.js'

import router from '@/router/'

import axios from 'axios'

import jwt from 'jsonwebtoken'

import dayjs from '@/plugins/dayjs.js'
import { useToast } from 'vue-toastification'

const toast = useToast()

var feideTools = new FeideTools()

export const userActions = {
  setLoggedIn(payload) {
    this.loggedin = payload
  },
  setLoginInformation(payload) {
    console.log('setLoginInformation got called ! (%j)', payload)
    this.setPnr(payload.pnr)
    this.loginInformation = payload
    this.setDisplayName(payload.displayName)
    /*
    payload.pnr = res.pid
    this.toast.info('vi har pnr fra :' + payload.pnr)
    payload.displayName = res.displayName
    payload.name = res.name
    payload.eduPersonPrimaryAffiliation = res.eduPersonPrimaryAffiliation
    payload.eduPersonPrincipalName = res.eduPersonPrincipalName
    payload.eduPersonAffiliation = res.eduPersonAffiliation
    payload.accessToken = token
    */
  },
  setDisplayName(payload) {
    this.displayName = payload
  },
  setPnr(payload) {
    this.pnr = payload
  },
  setFeideUser(payload) {
    this.feideuser = payload
  },
  setGuardian(payload) {
    this.guardian.pnr = payload.pnr || payload.guardian_pnr
    this.guardian.givenName =
      payload.givenName || payload.guardian_givenname || ''
    this.guardian.familyName =
      payload.familyName || payload.guardian_familyname || ''
    this.guardian.displayName =
      payload.displayName || payload.guardian_displayName || ''
    this.displayName = this.guardian.displayName
    this.guardian.street1 = payload.street1 || payload.guardian_street1 || ''
    this.guardian.street2 = payload.street2 || payload.guardian_street2 || ''
    this.guardian.postcode = payload.postcode || payload.guardian_postcode || ''
    this.guardian.city = payload.city || payload.guardian_city || ''
    this.guardian.phone = payload.phone || payload.guardian_phone || ''
    this.guardian.email = payload.email || payload.guardian_email || ''
    this.guardian.uid = payload.uid || ''
    this.guardian.pnrx = []
  },
  async saveGuardian(payload) {
    let aStore = adminStore()
    return new Promise((resolve) => {
      console.log('saveGuardian got called (%j)', payload)
      this.displayName = payload.givenName + ' ' + payload.familyName
      payload.displayName = this.displayName
      this.guardian = payload
      /*
      this.guardian.pnr = payload.pnr
      this.guardian.pnrx = payload.pnrx || []
      this.guardian.uid = payload.uid || ''
      this.guardian.givenName = payload.givenName  || ''
      this.guardian.familyName = payload.familyName  || ''
      this.guardian.displayName = payload.displayName  || ''
      this.guardian.street1 = payload.street1 || ''
      this.guardian.street2 = payload.street2  || ''
      this.guardian.postcode = payload.postcode  || ''
      this.guardian.city = payload.city  || ''
      this.guardian.phone = payload.phone  || ''
      this.guardian.email = payload.email  || ''
      */
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      aStore.postHTTP('user/saveguardian/saveg', pLoad).then((res) => {
        console.log('====>>>> GUARDIAN SAVED <<<<<< ======= (%j)', res)
        let resData = res.data || {}
        let dgraphRes = resData.dgraphresult || {}
        this.getGuardianInformation(payload.pnr)
        resolve(dgraphRes)
      })
    }) // promise
  },
  async getGuardianInformation(pnr) {
    let aStore = adminStore()
    return new Promise((resolve) => {
      let payload = {
        pnr: pnr
      }
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      aStore
        .postHTTP('user/getguardianinformation/guardian', pLoad)
        .then(
          (result) => {
            console.log('GET GUARDIAN INFORMATION (%j)', result)
            let resData = result.data || {}
            let dgraphRes = resData.dgraphresult || {}
            console.log('DGRAPH RES (%s) (%j)', dgraphRes.success, dgraphRes)
            let dgraphData = dgraphRes.data || {}
            console.log('DGRAPH DATA (%j)', dgraphData)
            if (dgraphRes.noresult) {
              resolve({ success: false, noresult: true })
            } else if (dgraphRes.success) {
              let dQuery = dgraphData.query || []
              if (dQuery.length > 1) {
                toast.error(
                  'MORE THAN ONE GUARDIN WITH PNR (' + pnr + ') REGISTERED'
                )
              }
              this.guardian = dQuery[0]
              resolve({ success: true, data: dQuery[0] })
            } else {
              resolve({
                success: false,
                error: true,
                errorMsg: dgraphRes.errorMsg
              })
            }
            // resolve({success: true, data: result})
          } // postHTTP
        )
        .catch((error) => {
          console.error(
            'admin ACTIONS GET GUARDIAN INFORMATION ERROR (%j)',
            error
          )
          resolve({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async findChildrenToGuardian(payload) {
    console.log('findChildrenToGuardian (%j)', payload)
    let aStore = adminStore()
    return new Promise((resolve) => {
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      aStore
        .postHTTP('user/findchildrentoguardian/guardianchildren', pLoad)
        .then((result) => {
          console.info('GET GUARDIAN INFORMATION (%j)', result)
          let resData = result.data || {}
          let dgraphRes = resData.dgraphresult || {}
          console.log('DGRAPH RES (%s) (%j)', dgraphRes.success, dgraphRes)
          let dgraphData = dgraphRes.data || {}
          console.log('DGRAPH DATA (%j)', dgraphData)
          if (dgraphRes.noresult) {
            resolve({ success: false, noresult: true })
          } else if (dgraphRes.success) {
            let dQuery = dgraphData[0].children || []
            resolve({ success: true, data: dQuery })
          } else {
            resolve({
              success: false,
              error: true,
              errorMsg: dgraphRes.errorMsg
            })
          }
          // resolve({success: true, data: result})
        })
        .catch((error) => {
          // postHTTP
          console.error(
            'admin ACTIONS GET GUARDIAN INFORMATION ERROR (%j)',
            error
          )
          resolve({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  setChild(payload) {
    console.log('setChild got called (%j)', payload)
    this.child = payload
  },
  setChildInformation(payload) {
    console.log('SET CHILD INFORMATION GOT CALLED (%J)', payload)
    this.childInformation = payload
  },
  async saveChildInformation(payload) {
    return new Promise((resolve) => {
      console.log('saveChildInformation got called (%j)', payload)
      let aStore = adminStore()
      let updatedPayload = payload
      updatedPayload.exitedTo = encodeLoad(payload.exitedTo || '')
      updatedPayload.likes = encodeLoad(payload.likes || '')
      updatedPayload.importantInformation = encodeLoad(
        payload.importantInformation || ''
      )
      updatedPayload.languageDetail = encodeLoad(payload.languageDetail || '')
      updatedPayload.language = encodeLoad(payload.language || '')
      updatedPayload.lookingForwardTo = encodeLoad(
        payload.lookingForwardTo || ''
      )
      updatedPayload.masters = encodeLoad(payload.masters || '')
      updatedPayload.numbers = encodeLoad(payload.numbers || '')
      updatedPayload.other = encodeLoad(payload.other || '')
      updatedPayload.schoolToKnow = encodeLoad(payload.schoolToKnow || '')
      updatedPayload.situations = encodeLoad(payload.situations || '')
      updatedPayload.social = encodeLoad(payload.social || '')

      let pLoad = {
        mutate: encodeLoad(JSON.stringify(updatedPayload))
      }
      aStore.postHTTP('user/savechildinfo/save', pLoad).then((res) => {
        console.log('====>>>> CHILD SAVED <<<<<< ======= (%j)', res)
        let resData = res.data || {}
        let dgraphRes = resData.dgraphresult || {}
        if (dgraphRes.success) {
          resolve({ success: true, uid: dgraphRes.uid })
        } else {
          resolve({
            success: false,
            error: true,
            errorMsg: 'could not save child information'
          })
        }
      })
    }) // promise
  },
  async saveChildObservations(payload) {
    return new Promise((resolve) => {
      console.log('saveChildObservations got called (%j)', payload)
      let aStore = adminStore()
      let updatedPayload = payload
      updatedPayload.exitedTo = encodeLoad(payload.exitedTo || '')
      updatedPayload.likes = encodeLoad(payload.likes || '')
      updatedPayload.importantInformation = encodeLoad(
        payload.importantInformation || ''
      )
      updatedPayload.languageDetail = encodeLoad(payload.languageDetail || '')
      updatedPayload.language = encodeLoad(payload.language || '')
      updatedPayload.lookingForwardTo = encodeLoad(
        payload.lookingForwardTo || ''
      )
      updatedPayload.masters = encodeLoad(payload.masters || '')
      updatedPayload.numbers = encodeLoad(payload.numbers || '')
      updatedPayload.other = encodeLoad(payload.other || '')
      updatedPayload.schoolToKnow = encodeLoad(payload.schoolToKnow || '')
      updatedPayload.situations = encodeLoad(payload.situations || '')
      updatedPayload.social = encodeLoad(payload.social || '')
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(updatedPayload))
      }
      aStore
        .postHTTP('user/savechildobservation/saveobs', pLoad)
        .then((res) => {
          console.log('====>>>> CHILD SAVED <<<<<< ======= (%j)', res)
          let resData = res.data || {}
          let dgraphRes = resData.dgraphresult || {}
          if (dgraphRes.success) {
            resolve({ success: true, uid: dgraphRes.uid })
          } else {
            resolve({
              success: false,
              error: true,
              errorMsg: 'could not save child information'
            })
          }
        })
    }) // promise
  },
  addAddedGuardian(pnr) {
    if (this.addedguardians.indexOf(pnr) > -1) return
    console.log('addAddedGuardian (%s)', pnr)
    this.addedguardians.push(pnr)
  },
  removeAddedGuardian(pnr) {
    let addIndex = this.addedguardians.indexOf(pnr)
    if (addIndex > -1) {
      this.addedguardians.splice(addIndex, 1)
    }
  },
  async saveKindergartenEmployeePnr(payload) {
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      aStore
        .postHTTP('user/savekindergartenemployeepnr/savepnr', pLoad)
        .then((res) => {
          console.log(
            '====>>>> saveKindergartenEmployeePnr <<<<<< ======= (%j)',
            res
          )
          let resData = res.data || {}
          let dgraphRes = resData.dgraphresult || {}
          if (dgraphRes.success) {
            resolve({ success: true, uid: dgraphRes.uid })
          }
        })
    }) // promise
  },
  findKindergartensToManager(pnr) {
    console.log('findKindergartensToManager got called:' + pnr)
    let aStore = adminStore()
    return new Promise((resolve, reject) => {
      let load = `{
       	query(func: eq(manager_pnr, "${pnr}")) {
		      uid
          kindergarten: ~kindergartenHasManager {
    				uid
						kindergarten_orgnr
    				kindergarten_name
  				  }
			    }
        }`
      let pLoad = {
        query: encodeLoad(load)
      }
      // console.log('=== ACCESS CLIENT TOKEN === : ' + accessClientToken)
      aStore
        .postHTTP('dgraph-api/dquery/findKindergartensToManager', pLoad)
        .then((response) => {
          // console.log('============================ RESPONSE ER =======')
          let responseData = response.data.dgraphresult || {}
          console.warn('======= RESPONSE DATA FROM checkUserExist ======')
          console.log(responseData)
          if (responseData.noresult) {
            console.log('== NO KINDERGARTEN MANAGER FOUND ==')
            resolve({
              error: false,
              success: false,
              nodata: true,
              successMsg: '== NO KINDERGARTEN MANAGER FOUND =='
            })
          } else {
            this.educatoruid = responseData[0].uid
            console.log('== KINDERGARTEN MANAGER  ==')
            resolve({
              success: true,
              data: responseData
            })
          }
        })
        .catch((error) => {
          console.error(
            '*** ERROR **** findKindergartensToManager had some problems ! : ' +
              error
          )
          reject({
            success: false,
            error: true,
            errorMsg:
              '*** ERROR *** check findKindergartensToManager had some problems: ' +
              error
          })
        })
    })
  }
}
